import TranslationService from '../../../services/translation.service';
const translationService = new TranslationService();
// const titleMap = {
//     camera: translationService.translate('camera'),
//     display: translationService.translate('display'),
//     mic: translationService.translate('microphone'),
//     touchPanel: translationService.translate('touchPanel')
// };


const DEVICE_STATUS =  {
  camera: {
    up:   {
      title: undefined,
      legendTitle: 'Connected',
      value: 'Good',
      icon: 'fa-fw fak fa-solid-camera-web-circle-check',
      disabledIcon: 'fa-fw fak fa-light-camera-web-circle-check',
      // svgSrc: 'dist/images/quick-pick/camera-conn.svg',
      colorClass: 'semantic-good',
      color: 'var(--good-color)'
    },
    down:   {
      title: undefined,
      legendTitle: 'Not Connected',
      value: 'Bad',
      icon: 'fa-fw fak fa-solid-camera-web-circle-xmark',
      disabledIcon: 'fa-fw fak fa-light-camera-web-circle-xmark',
      // svgSrc: 'dist/images/quick-pick/camera-not-conn.svg',
      colorClass: 'semantic-bad',
      color: 'var(--bad-color)'
    },
    none:   {
      title: undefined,
      legendTitle: 'Unknown',
      value: 'Neutral',
      icon: 'fa-fw fak fa-solid-camera-web-circle-question',
      disabledIcon: 'fa-fw fak fa-light-camera-web-circle-question',
      // svgSrc: 'dist/images/quick-pick/camera-unknown.svg',
      colorClass: 'semantic-neutral',
      color: 'var(--unknown-color)'
    },
  },
  display: {
    up:   {
      title: undefined,
      legendTitle: 'Connected',
      value: 'Good',
      icon: 'fa-fw fak fa-solid-display-circle-check',
      disabledIcon: 'fa-fw fak fa-light-display-circle-check',
      // svgSrc: 'dist/images/quick-pick/display-conn.svg',
      colorClass: 'semantic-good',
      color: 'var(--good-color)'
    },
    down:   {
      title: undefined,
      legendTitle: 'Not Connected',
      value: 'Bad',
      icon: 'fa-fw fak fa-solid-display-circle-xmark',
      disabledIcon: 'fa-fw fak fa-light-display-circle-xmark',
      // svgSrc: 'dist/images/quick-pick/display-not-conn.svg',
      colorClass: 'semantic-bad',
      color: 'var(--bad-color)'
    },
    none:   {
      title: undefined,
      legendTitle: 'Unknown',
      value: 'Neutral',
      icon: 'fa-fw fak fa-solid-display-circle-question',
      disabledIcon: 'fa-fw fak fa-light-display-circle-question',
      // svgSrc: 'dist/images/quick-pick/display-unknown.svg',
      colorClass: 'semantic-neutral',
      color: 'var(--unknown-color)'
    },
  },
  mic: {
    up:   {
      title: undefined,
      legendTitle: 'Connected',
      value: 'Good',
      icon: 'fa-fw fak fa-solid-microphone-circle-check',
      disabledIcon: 'fa-fw fak fa-light-microphone-circle-check',
      // svgSrc: 'dist/images/quick-pick/mic-conn.svg',
      colorClass: 'semantic-good',
      color: 'var(--good-color)'
    },
    down:   {
      title: undefined,
      legendTitle: 'Not Connected',
      value: 'Bad',
      icon: 'fa-fw fak fa-solid-microphone-circle-xmark',
      disabledIcon: 'fa-fw fak fa-light-microphone-circle-xmark',
      // svgSrc: 'dist/images/quick-pick/mic-not-conn.svg',
      colorClass: 'semantic-bad',
      color: 'var(--bad-color)'
    },
    none:   {
      title: undefined,
      legendTitle: 'Unknown',
      value: 'Neutral',
      icon: 'fa-fw fak fa-solid-microphone-circle-question',
      disabledIcon: 'fa-fw fak fa-light-microphone-circle-question',
      // svgSrc: 'dist/images/quick-pick/mic-unknown.svg',
      colorClass: 'semantic-neutral',
      color: 'var(--unknown-color)'
    },
  },
  touchPanel: {
    up: {
      title: undefined,
      legendTitle: 'Connected',
      value: 'Good',
      icon: 'fa-fw fak fa-solid-tablet-screen-circle-check',
      disabledIcon: 'fa-fw fak fa-light-tablet-screen-circle-check',
      // svgSrc: 'dist/images/quick-pick/touchpad-conn.svg',
      colorClass: 'semantic-good',
      color: 'var(--good-color)'
    },
    down:   {
      title: undefined,
      legendTitle: 'Not Connected',
      value: 'Bad',
      icon: 'fa-fw fak fa-solid-tablet-screen-circle-xmark',
      disabledIcon: 'fa-fw fak fa-light-tablet-screen-circle-xmark',
      // svgSrc: 'dist/images/quick-pick/touchpad-not-conn.svg',
      colorClass: 'semantic-bad',
      color: 'var(--bad-color)'
    },
    none:   {
      title: undefined,
      legendTitle: 'Unknown',
      value: 'Neutral',
      icon: 'fa-fw fak fa-solid-tablet-screen-circle-question',
      disabledIcon: 'fa-fw fak fa-light-tablet-screen-circle-question',
      // svgSrc: 'dist/images/quick-pick/touchpad-unknown.svg',
      colorClass: 'semantic-neutral',
      color: 'var(--unknown-color)'
    },
  }
};

/**
 * Maps data from http://assurance-query-service.qa.us1.vyopta.cloud/#_get_cpmm_api_v1_orgs_orgid_endpoints_endpointid
 * to a usable model
 */
export default class EndpointDevices {
    constructor(endpointData) {
        this.peripherals = [];
        if (Array.isArray(endpointData.device_infos)) {
            this.peripherals = endpointData.device_infos.map(function(deviceInfo) {
                let peripheralNumber = deviceInfo.id ? deviceInfo.id.split('-')[1] : undefined;
                let peripheralType = deviceInfo.id ? deviceInfo.id.split('-')[0] : undefined;
                let connected = deviceInfo.status && deviceInfo.status.toLowerCase() === 'up';//getConnectedIds(endpointData, peripheralType).includes(peripheralNumber);
                let notConnected = deviceInfo.status && deviceInfo.status.toLowerCase() === 'down'; //getNotConnectedIds(endpointData, peripheralType).includes(peripheralNumber);
                return {
                    id: deviceInfo.id,
                    name: deviceInfo.name,
                    type: deviceInfo.type,
                    connected: connected,
                    notConnected: notConnected,
                    connectedLabel: peripheralNumber ? (connected ? translationService.translate('connected') : notConnected ? translationService.translate('notConnected') :translationService.translate('unknown')) : '',
                    image: getImage(peripheralType, connected, notConnected),
                    icon: getIcon(deviceInfo.type, deviceInfo.status)
                };
            });
        }
    }

    getPeripherals(type) {
        if (type) {
            return this.peripherals.filter(function(peripheral) {
                return peripheral.type === type;
            });
        }
        return this.peripherals;
    }
}

const imageMap = {
    camera: {
      green: 'dist/images/call-details/video-green.svg',
      red: 'dist/images/call-details/video-red.svg',
      gray: 'dist/images/call-details/video-gray.svg',
    },
    display: {
      green: 'dist/images/call-details/tv-green.svg',
      red: 'dist/images/call-details/tv-red.svg',
      gray: 'dist/images/call-details/tv-gray.svg',
    },
    mic: {
      green: 'dist/images/call-details/microphone-green.svg',
      red: 'dist/images/call-details/microphone-red.svg', 
      gray: 'dist/images/call-details/microphone-gray.svg',
    },
    touchPanel: {
      green: 'dist/images/call-details/touchpad-green.svg',
      red: 'dist/images/call-details/touchpad-red.svg',
      gray: 'dist/images/call-details/touchpad-gray.svg',
    }
};


function getImage(peripheralType, connected, notConnected) {
    return peripheralType ? imageMap[peripheralType][connected ? 'green' : notConnected ? 'red' : 'gray'] : undefined;
}
function getIcon(peripheralType, status) {
    let devicestatus = DEVICE_STATUS[peripheralType][status ? status.toLowerCase() : 'none'];
    return devicestatus.disabledIcon + ' ' + devicestatus.colorClass;
}
